<script>
import useSharedData from "@/use/SharedData";
import useConfiguration from "@/use/Configuration";
import {onMounted} from "vue";
import useSharedSelectData from "@/use/SharedSelectData";
import StrBalanceAutocomplete from "@/views/Absence/Balance/Components/StrBalanceAutocomplete.vue";
import usePeriodicity from "@/use/Periodicity";
import {useSecurityStore} from "@/stores/Security";

export default {
    components: {StrBalanceAutocomplete},
    setup() {
        const {backgroundColor} = useSharedData();
        const {loading, configurations, findAll, save} = useConfiguration();
        const {itemsPerPageList, atsModes, profiles} = useSharedSelectData();
        const {monthNumberDays} = usePeriodicity();
        
        const securityStore = useSecurityStore();
        
        onMounted(() => findAll());
        
        return {
            securityStore,
            monthNumberDays,
            itemsPerPageList,
            loading,
            backgroundColor,
            configurations,
            atsModes,
            profiles,
            save,
        }
    }
}
</script>

<template>
    <w-app :title="$t('module.configuration')">
        <template #rightToolbar>
            <w-btn-apply
                :show="securityStore.authorities['UPDATE_PAY_SLIP_PARAM']"
                :loading="loading"
                @press="save"
            />
        </template>
        
        <template #content>
            <v-tabs
                dense
                height="35"
                color="teal"
                :background-color="backgroundColor"
            >
                <v-tab>{{ $t('common.general') }}</v-tab>
                <v-tab>{{ $t('common.display') }}</v-tab>
                <v-tab>{{ $t('pay_slip.pay_sections') }}</v-tab>
                <v-tab>{{ $t('pay_slip.import') }}</v-tab>
                <v-tab>{{ $t('common.holiday') }}</v-tab>
                <v-tab>{{ $t('pay_slip.rung') }}</v-tab>
                <v-tab>{{ $t('pay_slip.iep') }}</v-tab>
                
                <v-tab-item>
                    <v-container fluid>
                        <v-row>
                            <v-col cols="3">
                                <w-label :label="$t('pay_slip.pay_calculation_mode')"/>
                                <w-enum-select
                                    v-model="configurations[70].booll"
                                    :items="[
                                        {id: false, name: $t('pay_slip.pay_calculation_mode_wims')},
                                        {id: true, name: $t('pay_slip.pay_calculation_mode_pc_paie')},
                                    ]"
                                    not-clearable
                                />
                            </v-col>
                            <v-col cols="3">
                                <w-label :label="$t('pay_slip.open_days_number')"/>
                                <w-text-field
                                    v-model="configurations[2].intt"
                                    type="number"
                                    not-clearable
                                />
                            </v-col>
                            <v-col cols="3">
                                <w-label :label="$t('pay_slip.day_hours_number')"/>
                                <w-text-field
                                    v-model="configurations[19].intt"
                                    type="number"
                                    not-clearable
                                />
                            </v-col>
                            <v-col cols="3">
                                <w-label :label="$t('pay_slip.open_hours_number')"/>
                                <w-text-field
                                    v-model="configurations[18].floatt"
                                    type="number"
                                    not-clearable
                                />
                            </v-col>
                            <v-col cols="3">
                                <w-label :label="$t('pay_slip.calculation_profile')"/>
                                <w-enum-select
                                    v-model="configurations[20].strr"
                                    :items="profiles"
                                    not-clearable
                                />
                            </v-col>
                            <v-col cols="3">
                                <w-label :label="$t('pay_slip.employer_charge')"/>
                                <w-text-field
                                    v-model="configurations[47].floatt"
                                    type="number"
                                    not-clearable
                                />
                            </v-col>
                            <v-col cols="3">
                                <w-label :label="$t('pay_slip.last_pay_state')"/>
                                <w-enum-select
                                    v-model="configurations[86].strr"
                                    :items="[
                                        {id: 'PAY_SLIP_ANNEX_VALIDATE', name: $t('pay_slip.annex_validated')},
                                        {id: 'PAY_SLIP_ANNEX_CLOSED', name: $t('pay_slip.annex_closed')},
                                        {id: 'PAY_SLIP_CLOSED', name: $t('pay_slip.pay_closed')},
                                    ]"
                                    not-clearable
                                />
                            </v-col>
                            <v-col cols="3">
                                <v-checkbox
                                    v-model="configurations[87].booll"
                                    :label="$t('pay_slip.close_even_open_pays')"
                                    hide-details
                                />
                            </v-col>
                            <v-col cols="3">
                                <w-label :label="$t('pay_slip.month_start_month')"/>
                                <w-enum-select
                                    v-model="configurations[92].intt"
                                    :items="monthNumberDays"
                                    not-clearable
                                />
                            </v-col>
                            <v-col cols="3">
                                <w-label :label="$t('pay_slip.month_end_month')"/>
                                <w-enum-select
                                    v-model="configurations[93].intt"
                                    :items="monthNumberDays"
                                    not-clearable
                                />
                            </v-col>
                            <v-col cols="3">
                                <w-label :label="$t('pay_slip.calculation_ats_mode')"/>
                                <w-enum-select
                                    v-model="configurations[99].strr"
                                    :items="atsModes"
                                    not-clearable
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
                <v-tab-item>
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="6">
                                <v-row>
                                    <v-col cols="12">
                                        <w-label :label="$t('pay_slip.default_rows_per_page')"/>
                                        <w-enum-select
                                            v-model="configurations[71].intt"
                                            :items="itemsPerPageList"
                                            not-clearable
                                        />
                                    </v-col>
                                    <v-col cols="12">
                                        <w-label :label="$t('pay_slip.default_state')"/>
                                        <w-enum-select
                                            v-model="configurations[72].booll"
                                            :items="[
                                                {id: null, name: $t('common.all')},
                                                {id: true, name: $t('common.locked')},
                                                {id: false, name: $t('common.open')},
                                            ]"
                                            not-clearable
                                        />
                                    </v-col>
                                    <v-col cols="12">
                                        <w-label :label="$t('pay_slip.pay_display')"/>
                                        <w-enum-select
                                            v-model="configurations[73].strr"
                                            :items="[
                                                {id: 'LAST_ONE', name: $t('pay_slip.pay_display_newer')},
                                                {id: 'FIRST_ONE', name: $t('pay_slip.pay_display_older')},
                                            ]"
                                            not-clearable
                                        />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
                <v-tab-item>
                    <v-container fluid>
                        <v-row>
                            <v-col cols="4">
                                <strong>SALAIRE DE POSTE</strong>
                                <text-field-pay-section v-model="configurations[10].strr"/>
                            </v-col>
                            <v-col cols="4">
                                <strong>RETENUE SECU. SLE.</strong>
                                <text-field-pay-section v-model="configurations[11].strr"/>
                            </v-col>
                            <v-col cols="4">
                                <strong>RETENUE IMPOT 10%</strong>
                                <text-field-pay-section v-model="configurations[37].strr"/>
                            </v-col>
                            <v-col cols="4">
                                <strong>BASE IMPOSABLE IRG/MOIS</strong>
                                <text-field-pay-section v-model="configurations[12].strr"/>
                            </v-col>
                            <v-col cols="4">
                                <strong>RETENUE IRG</strong>
                                <text-field-pay-section v-model="configurations[13].strr"/>
                            </v-col>
                            <v-col cols="4">
                                <strong>TOTAL DES GAINS</strong>
                                <text-field-pay-section v-model="configurations[14].strr"/>
                            </v-col>
                            <v-col cols="4">
                                <strong>TOTAL DES RETENUES</strong>
                                <text-field-pay-section v-model="configurations[15].strr"/>
                            </v-col>
                            <v-col cols="4">
                                <strong>NET A PAYER</strong>
                                <text-field-pay-section v-model="configurations[16].strr"/>
                            </v-col>
                            <v-col cols="4">
                                <strong>TOTAL CNAS</strong>
                                <text-field-pay-section v-model="configurations[26].strr"/>
                            </v-col>
                            <v-col cols="4">
                                <strong>MASSE SALARIALE</strong>
                                <text-field-pay-section v-model="configurations[25].strr"/>
                            </v-col>
                            <v-col cols="4">
                                <strong>REGUL/IRG NOMBRE MOIS</strong>
                                <text-field-pay-section v-model="configurations[97].strr"/>
                            </v-col>
                            <v-col cols="4">
                                <strong>TEMPS DE TRAVAIL EN JOURS (CNAS)</strong>
                                <text-field-pay-section v-model="configurations[98].strr"/>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
                <v-tab-item>
                    <v-container fluid>
                        <v-row>
                            <v-col cols="4">
                                <w-label :label="$t('module.debt')"/>
                                <text-field-pay-section v-model="configurations[94].strr"/>
                            </v-col>
                            <v-col cols="4">
                                <w-label :label="$t('module.pay_day_advance')"/>
                                <text-field-pay-section v-model="configurations[95].strr"/>
                            </v-col>
                            <v-col cols="4">
                                <w-label :label="$t('pay_slip.mutual')"/>
                                <text-field-pay-section v-model="configurations[17].strr"/>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
                <v-tab-item>
                    <v-container fluid>
                        <v-row>
                            <v-col cols="3">
                                <w-label :label="$t('module.balance')"/>
                                <str-balance-autocomplete v-model="configurations[83].longg"/>
                            </v-col>
                            <v-col cols="3">
                                <w-label :label="$t('module.absence_reason')"/>
                                <str-absence-reason-autocomplete v-model="configurations[88].longg"/>
                            </v-col>
                            <v-col cols="3">
                                <w-label :label="$t('balance.basic_base')"/>
                                <text-field-pay-section v-model="configurations[84].strr"/>
                            </v-col>
                            <v-col cols="3">
                                <w-label :label="$t('absence_request.days_number')"/>
                                <w-text-field v-model="configurations[85].intt" type="number"/>
                            </v-col>
                            <v-col cols="3">
                                <w-label :label="$t('balance.plate_base')"/>
                                <text-field-pay-section v-model="configurations[90].strr"/>
                            </v-col>
                            <v-col cols="3">
                                <w-label :label="$t('pay_slip.holiday_absence_pay_section')"/>
                                <text-field-pay-section v-model="configurations[91].strr"/>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
                <v-tab-item>
                    <v-container fluid>
                        <v-row>
                            <v-col cols="4">
                                <w-label :label="$t('pay_slip.rung_reference_start_year')"/>
                                <w-text-field v-model="configurations[0].intt" type="number"/>
                            </v-col>
                            <v-col cols="4">
                                <w-label :label="$t('pay_slip.rung_reference_end_year')"/>
                                <w-text-field v-model="configurations[27].intt" type="number"/>
                            </v-col>
                            <v-col cols="4">
                                <w-label :label="$t('pay_slip.rung_periodicity')"/>
                                <w-text-field v-model="configurations[3].intt" type="number"/>
                            </v-col>
                            <v-col cols="4">
                                <w-label :label="$t('common.increment')"/>
                                <w-enum-select
                                    v-model="configurations[8].booll"
                                    :items="[
                                        {id: false, name: $t('common.percent')},
                                        {id: true, name: $t('common.value')},
                                    ]"
                                    not-clearable
                                />
                            </v-col>
                            <v-col cols="4">
                                <w-label :label="$t('common.value')"/>
                                <w-text-field v-model="configurations[9].intt" type="number"/>
                            </v-col>
                            <v-col cols="4">
                                <w-label :label="$t('pay_slip.rung_display_up_to')"/>
                                <w-text-field v-model="configurations[4].intt" type="number"/>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
                <v-tab-item>
                    <v-container fluid>
                        <v-row>
                            <v-col cols="6">
                                <w-label :label="$t('pay_slip.iep_reference_start_year')"/>
                                <w-text-field v-model="configurations[5].intt" type="number"/>
                            </v-col>
                            <v-col cols="6">
                                <w-label :label="$t('pay_slip.iep_reference_end_year')"/>
                                <w-text-field v-model="configurations[28].intt" type="number"/>
                            </v-col>
                            <v-col cols="6">
                                <w-label :label="$t('pay_slip.iep_periodicity')"/>
                                <w-text-field v-model="configurations[6].intt" type="number"/>
                            </v-col>
                            <v-col cols="6">
                                <w-label :label="$t('common.increment')"/>
                                <w-text-field v-model="configurations[7].intt" type="number"/>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
            </v-tabs>
        </template>
    </w-app>
</template>